import React from 'react';
import type { IconProps } from '../../types';

export const FacebookIcon: React.FC<IconProps> = ({
  className = '',
  width = 6,
  height = 6,
  fill = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 6 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M3.18943 0.3125C1.66224 0.3125 0.41272 1.55924 0.41272 3.09476C0.41272 4.48311 1.42899 5.63545 2.75626 5.8437V3.9H2.05098V3.09476H2.75626V2.48111C2.75626 1.78415 3.16999 1.40097 3.80586 1.40097C4.10852 1.40097 4.42506 1.45373 4.42506 1.45373V2.13957H4.0752C3.73088 2.13957 3.62259 2.35338 3.62259 2.57274V3.09476H4.39452L4.26957 3.9H3.62259V5.8437C4.27691 5.74036 4.87272 5.40651 5.30248 4.90241C5.73224 4.39831 5.96762 3.75718 5.96613 3.09476C5.96613 1.55924 4.71661 0.3125 3.18943 0.3125Z'
        fill={fill}
      />
    </svg>
  );
};
